<template>
  <ul
    class="bg-neutral-secondary marker:text-brand-primary list-disc list-inside p-2"
  >
    <template v-for="(item, index) of SHEBA_NUMBER_CONDITIONS" :key="index">
      <li>
        <NText variant="caption2">{{ item.title }}</NText>

        <a v-if="item.link" :href="item.link" target="_blank">
          <NText variant="caption2" class="text-brand-primary">
            ({{ t('common.show') }})
          </NText>
        </a>
      </li>
    </template>
  </ul>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

type Conditions = { title: string; link?: string }[];

const { t } = useI18n();

const SHEBA_NUMBER_CONDITIONS: Conditions = [
  { title: t('withdrawal.shebaNumberConditions.allowedBankAccountMessage') },
  {
    title: t('withdrawal.shebaNumberConditions.calculateShebaNumberGuide'),
    link: 'https://help.irfarabi.com/?p=4358',
  },
];
</script>
